export const TYPE_ENTREPRISE = [
    { id: 'AUT', description: 'Autre' },
    { id: 'BIL', description: 'Billeterie' },
    { id: 'CAM', description: 'Camping' },
    { id: 'RES', description: 'Réservation' },
    { id: 'ZEC', description: 'Zec' },
    { id: 'POS', description: 'POS' },
    { id: 'HOT', description: 'Hôtel' },
    { id: 'SLA', description: 'Station de lavage' },
    { id: 'TRA', description: 'Transport' },
    { id: 'LOC', description: 'Location' },
    { id: 'CDJ', description: 'Camp de jour' },
    { id: 'BIJ', description: 'Bijouterie' },
]